<template>
  <div class="col-sm-12 nopads">
    <Transition name="fade">
      <div v-if="items.length > 0" class="col-sm-12 list-content result-table pointer">
          <vue3-datatable
              ref="resultTable"
              :rows="items"
              :columns="fields"
              :pagination="false"
              :sticky-header="true"
              :height="items.length > 5 ? '40vh' : '100%'"
              :sortable="true"
              skin="bh-table-compact"
              row-class="routa-table-row"
              cell-class="routa-table-cell"
              @row-click="emitDetails"
          >
          </vue3-datatable>
      </div>
    </Transition>
  </div>
</template>

<script>
import {timeUtils} from '../mixins/TimeUtils'
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'TrafficControlReportList',
    components: {Vue3Datatable},
    mixins: [timeUtils],
    props: {
        results: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data() {
        return {
            fields: [
                {field: 'id', title: this.$t('danger_report.report_id'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'contract', title: this.$t('danger_report.contract'), sort: true, headerClass: 'routa-table-header'},
                {field: 'start_time', title: this.$t('danger_report.event_time'), sort: true, headerClass: 'routa-table-header'},
                {field: 'end_time', title: this.$t('danger_report.event_time'), sort: true, headerClass: 'routa-table-header'},
                {field: 'road_name', title: this.$t('road_sign.road_name'), sort: true, headerClass: 'routa-table-header'},
                {field: 'road_number', title: this.$t('map.road_number'), sort: true, headerClass: 'routa-table-header'},
                {field: 'road_section', title: this.$t('map.road_section'), sort: true, headerClass: 'routa-table-header'},
                {field: 'description', title: this.$t('danger_report.description'), sort: true, headerClass: 'routa-table-header'},
            ],
            items: []
        }
    },
    watch: {
        results: function () {
            this.initTableItems()
        }
    },
    mounted: function () {
        this.initTableItems()
    },
    methods: {
        initTableItems: function () {
            this.items = []
            const temp = []
            this.results.forEach(function (item) {
                temp.push(
                    {
                        id: item.id,
                        start_time: this.toLocalTime(item.start_time),
                        end_time: this.toLocalTime(item.end_time),
                        road_name: item.road_name,
                        road_number: item.road_number,
                        road_section: item.road_section,
                        description: item.description,
                        contract: item.contract ? item.contract.name : "",
                    }
                )
            }, this)
            this.$nextTick(() => this.items = temp)
        },
        emitDetails: function (details) {
            let report = this.results.find(item => item.id === details.id)
            this.$emit('details', report)
        }
    }
}
</script>
